import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import {TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {ChangeBusinessDialog} from "./dialogs/changeBusiness.dialog";
import {MatIconModule, MatListModule} from "@angular/material";
import {HttpClientInterceptor} from "../interceptors/http.interceptor";

@NgModule({
    imports: [ RouterModule, CommonModule,
        MatListModule,
        MatIconModule,
        TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        }
      }) ],

    declarations: [ SidebarComponent, ChangeBusinessDialog ],
    entryComponents: [ChangeBusinessDialog],
    providers: [      {provide: HTTP_INTERCEPTORS, useClass: HttpClientInterceptor, multi: true},
    ],
    exports: [ SidebarComponent ]

})

export class SidebarModule {}
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.module.ts